import { Component, OnInit } from '@angular/core';
import {ModalController, PopoverController} from "@ionic/angular";
import {Api, User} from "../../providers";
import {EditPostPage} from "../edit-post/edit-post.page";

@Component({
  selector: 'app-postpopover',
  templateUrl: './postpopover.page.html',
  styleUrls: ['./postpopover.page.scss'],
})
export class PostpopoverPage implements OnInit {
  public delete:any;
  public mdl:any;
  public post:any;
  constructor(public api:Api, public user: User,public popoverController: PopoverController,public modalController:ModalController) { }

  public dismissModal() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.popoverController.dismiss({
      'dismissed': true,
      'post': this.post,
    });
  }
  ngOnInit() {

  }
  async editPost(){
    this.popoverController.dismiss();
    const modal = await this.modalController.create({
      component: EditPostPage,
      // cssClass: 'my-custom-class',
      componentProps: {
        post:this.post,
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
  }
  deletePost(){
    this.popoverController.dismiss();
    this.delete(this.mdl)
  }
}
